export default {
  allGameBetTypeList(state) {
    // return state.allGame.reduce((a, b) => {
    //   if (!a[b.type]) {
    //     a[b.type] = [];
    //   }
    //   a[b.type].push(b);
    //   return a;
    // }, {});
    return Object.keys(state.allGame).reduce((a, b) => {
      if (!a[state.allGame[b].type]) {
        a[state.allGame[b].type] = [];
      }
      a[state.allGame[b].type].push(state.allGame[b]);
      return a;
    }, {});
  }
};



// WEBPACK FOOTER //
// ./src/store/getters.js